import { utc, ISO_8601 } from "moment";
const columns = [
  { field: "spot", headerName: "Spot", width: 250 },
  {
    field: "startTime",
    headerName: "Date",
    type: "date",
    width: 110,
    valueFormatter: ({ value }) => utc(value, ISO_8601).format("yyyy/MM/DD"),
  },
  {
    field: "rating",
    headerName: "Rating",
    valueFormatter: ({ value }) => `${value}/5`,
  },
  {
    field: "swell1Height",
    headerName: "Swell 1 Height",
    width: 150,
  },
  {
    field: "swell1Dir",
    headerName: "Swell 1 Dir",
    width: 150,
  },
  {
    field: "swell1Period",
    headerName: "Swell 1 Period",
    width: 150,
  },
  {
    field: "swell2Height",
    headerName: "Swell 2 Height",
    width: 150,
  },
  {
    field: "swell2Dir",
    headerName: "Swell 2 Dir",
    width: 150,
  },
  {
    field: "swell2Period",
    headerName: "Swell 2 Period",
    width: 150,
  },
  {
    field: "swell3Height",
    headerName: "Swell 3 Height",
    width: 150,
  },
  {
    field: "swell3Dir",
    headerName: "Swell 3 Dir",
    width: 150,
  },
  {
    field: "swell3Period",
    headerName: "Swell 3 Period",
    width: 150,
  },
];

export default columns;
